<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="addRemarks()">
  <p>{{ 'cart.cart-remarks-dialog.description' | translate }}</p>
  <div *ngIf="isNlSalesOrganization$ | async">
    <p>
      {{ 'cart.cart-remarks-dialog.secundaryDescription' | translate }}
      <a href="https://www.agrifirm.nl/over-ons/contact-locaties/">{{ 'cart.cart-remarks-dialog.order-desk' | translate }}</a>
    </p>
    <p>{{ 'cart.cart-remarks-dialog.tertiaryDescription' | translate }}</p>
  </div>
  <div [formGroup]="remarksGroup" class="spacing--margin-top">
    <mat-form-field data-test="column-remarks__add-remarks" class="remarks-input">
      <mat-label>{{ 'cart.cart-remarks-dialog.title' | translate }}</mat-label>
      <input data-test="column-remarks__remarks-input" matInput formControlName="remarks" [maxlength]="150" />
    </mat-form-field>
  </div>
</agr-dialog>
